import { Link } from "react-router-dom";

import type { ListingAgent as ListingAgentType } from "@gql";
import Wave from "@assets/images/red_and_gold_wave.jpg";

import * as styles from "./ListingAgent.styles";

interface Props {
  listingAgent: ListingAgentType;
}

const ListingAgent = ({ listingAgent }: Props) => {
  const renderListingAgentLink = () => {
    if (!listingAgent.teamMember)
      return (
        <h2 css={styles.header}>
          <a href={listingAgent.website}>{listingAgent.name}</a>
        </h2>
      );

    return (
      <>
        <img
          src={listingAgent.teamMember.avatarThumb}
          alt={listingAgent.name}
          css={styles.container}
          className="img-circle"
        />
        <h2 css={styles.header}>
          <Link to={`/team_members/${listingAgent.teamMember.slug}`}>{listingAgent.name}</Link>
        </h2>
      </>
    );
  };

  const renderPosition = () => {
    if (!listingAgent.position) return null;
    return <p css={styles.position}>{listingAgent.position}</p>;
  };

  const renderWave = () => {
    if (!listingAgent.teamMember) return null;

    return (
      <div css={styles.waveContainer}>
        <img src={Wave} alt="Listing agent footer wave" />
      </div>
    );
  };

  return (
    <div data-testid="listing-agent" css={styles.listingAgent}>
      <div css={styles.container}>
        {renderListingAgentLink()}
        {renderPosition()}
      </div>
      <ul css={styles.details}>
        <li>{listingAgent.telephone}</li>
      </ul>
      {renderWave()}
    </div>
  );
};

export { ListingAgent };
